import React, { Component } from 'react';

export default class ImageCard extends Component {

    render() {
        return (
            <div className='image-card-base'>
                <div className="image-card" id={"image-card-" + this.props.item.id} onClick={() => { this.props.partSelectHandler(this.props.item.id, this.props.item.image) }}>
                    <img alt={this.props.item.name} src={this.props.item.image} />


                </div>
                <svg className='image-card-check' id={"image-card-check-" + this.props.item.id} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.793 1.3335H5.20634C2.77967 1.3335 1.33301 2.78016 1.33301 5.20683V10.7868C1.33301 13.2202 2.77967 14.6668 5.20634 14.6668H10.7863C13.213 14.6668 14.6597 13.2202 14.6597 10.7935V5.20683C14.6663 2.78016 13.2197 1.3335 10.793 1.3335ZM11.1863 6.46683L7.40634 10.2468C7.31301 10.3402 7.18634 10.3935 7.05301 10.3935C6.91967 10.3935 6.79301 10.3402 6.69967 10.2468L4.81301 8.36016C4.61967 8.16683 4.61967 7.84683 4.81301 7.6535C5.00634 7.46016 5.32634 7.46016 5.51967 7.6535L7.05301 9.18683L10.4797 5.76016C10.673 5.56683 10.993 5.56683 11.1863 5.76016C11.3797 5.9535 11.3797 6.26683 11.1863 6.46683Z" fill="#8F1105" />
                </svg>
            </div>

        )
    }
}